<template>
  <svg
    :width="Math.ceil(size*(384/512))"
    :height="size"
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
  >
    <path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" :fill="currentColor"/>
  </svg>
</template>

<script>
import IconMixin from '@/mixins/icon';

export default {
  mixins: [IconMixin]
};
</script>
